import React from 'react';
import PropTypes from 'prop-types';

// Style and SEO
import { Col, Grid, Row, styled, up, css } from '@smooth-ui/core-sc';
import Helmet from 'react-helmet';

import { Link } from 'react-router-dom';

import { withSettings } from '../../containers/WebApp/SettingsContext';
import PrivateComponent from '_platform/src/utils/PrivateComponent';

import VideoEmbed from '../../components/VideoEmbed/VideoEmbed';

import IconWrapper from '_platform/src/components/SvgIcon/IconWrapper';

import BgImage from 'components/CustomComponents/Backgrounds/BgImage';

import BgIntroImage from './images/bg-intro.jpg';

import Step1Image from './images/step1.svg';
import Step2Image from './images/step2.svg';
import Step3Image from './images/step3.svg';
import Step4Image from './images/step4.svg';

import Btn1Image from './images/btn1.jpg';
import Btn2Image from './images/btn2.jpg';
import Btn3Image from './images/btn3.jpg';

/*import PictureBanner from 'components/CustomComponents/Banners/PictureBanner';

import DesktopBanner from '../PromotionsPage/images/Easter-promo-GoodWe.png';
import TabletBanner from '../PromotionsPage/images/Easter-promo-GoodWe.png';
import MobileBanner from '../PromotionsPage/images/Easter-promo-GoodWe.png';*/

import TimedComponent from 'components/TimedComponent/TimedComponent';

const VideoContainer = styled.div`
  border-radius: 28px;
  overflow: hidden;
  margin-bottom: 50px;
  overflow: hidden;
`;

const IntroContainer = styled.div`
  background: url(${BgIntroImage});
  background-size: cover;
  color: white;
  text-align: center;
  border-radius: 28px;
  padding: 2em;
  box-shadow: 0px 10px 15px #00000029;
  margin-bottom: 50px;
  ${up(
    'sm',
    css`
      padding: 2em 5em;
    `
  )}

  ul {
    list-style-position: inside;
  }

  table {
    border-collapse: collapse;
    margin: 0 auto;
    td,
    th {
      padding: 5px;
      border: 1px solid white;
    }
  }
`;

const StepsRow = styled(Row)`
  margin-bottom: 25px;
`;

const StepContainer = styled.div`
  width: 100%;
  background-color: #e2e2e2;
  border-radius: 28px;
  padding: 2em;
  margin-bottom: 40px;
  text-align: center;
  h2 {
    font-size: 23px;
  }
`;

const HomeLinksContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  ${up(
    'sm',
    css`
      flex-direction: row;
      justify-content: space-between;
    `
  )}
`;

const HomeLink = styled(Link)`
  border-radius: 14px;
  color: white;
  text-transform: uppercase;
  width: 100%;
  height: 150px;
  margin-bottom: 25px;
  display: flex;
  background-size: cover;
  background-position: center center;
  align-items: center;
  justify-content: center;
  font-size: 25px;
  font-weight: bold;
  text-decoration: none;
  text-align: center;
  padding: 10px;
  ${up(
    'sm',
    css`
      width: 30%;
      border-radius: 28px;
      height: 280px;
    `
  )}

  &.btn1 {
    background-image: url(${Btn1Image});
  }

  &.btn2 {
    background-image: url(${Btn2Image});
  }

  &.btn3 {
    background-image: url(${Btn3Image});
  }

  span {
    border: 2px white solid;
    border-radius: 28px;
    padding: 0 10px;
    ${up(
      'md',
      css`
        padding: 0 20px;
      `
    )}
  }
`;

const HomePage = ({ settings }) => {
  return (
    <div className="page-container">
      <Helmet>
        {/* <meta name="description" content="Page description" /> */}
      </Helmet>

      <PrivateComponent
        redirectOnError={{
          pathname: settings.settingsApp.loginPagePath || '/login/',
        }}
      >
        <BgImage>
          <Grid>
            <Row justifyContent="center">
              {/*<Col sm={12} md={8}>
                <div className="spacer--bottom">
                  <Link to="/promotions">
                    <PictureBanner
                      bannerDesktop={DesktopBanner}
                      bannerTablet={TabletBanner}
                      bannerMobile={MobileBanner}
                      altText="Easter Prize Draw. Win $1000 in reward points* PLUS a signed Alex Carey cricket bat. *Terms and conditions apply."
                    />
                  </Link>
                </div>
                <div className="spacer--bottom">
                  <p className="text--center">
                    Thank you for participating in the GoodWe Rewards program,
                    we have now reached our maximum of rewards claims. You can
                    of course still use your claimed points via the Rewards
                    page.
                  </p>
                </div>
              </Col>*/}
              <Col md={12}>
                <IntroContainer>
                  <h1>Welcome To GoodWe Rewards</h1>
                  <div className="text--large">
                    <p>
                      Introducing the GoodWe Rewards Program, where you can earn
                      points for eligible GoodWe models:
                      <br />
                      Eligible models include:
                    </p>
                    <TimedComponent start="01-06-2026">
                      <table>
                        <tr>
                          <th>Model Number: </th>
                          <th>Value: </th>
                        </tr>
                        <tr>
                          <td>GW5.1-BAT-D-G20</td>
                          <td>75 points - $75 AUD</td>
                        </tr>
                        <tr>
                          <td>GW5.1-BAT-D-G21</td>
                          <td>75 points - $75 AUD</td>
                        </tr>
                        <tr>
                          <td>GW6.0-BAT-D-G20</td>
                          <td>75 points - $75 AUD</td>
                        </tr>
                        <tr>
                          <td>GW8.3-BAT-D-G20</td>
                          <td>120 points - $120 AUD</td>
                        </tr>
                        <tr>
                          <td>GW8.3-BAT-D-G21</td>
                          <td>120 points - $120 AUD</td>
                        </tr>
                        <tr>
                          <td>GW9.0-BAT-D-G20</td>
                          <td>120 points - $120 AUD</td>
                        </tr>
                        <tr>
                          <td>GW60KWH-D-10</td>
                          <td>3000 points - $3000 AUD</td>
                        </tr>
                        <tr>
                          <td>GW60KWH-D-10 (Extension)</td>
                          <td>3000 points - $3000 AUD</td>
                        </tr>
                        <tr>
                          <td>GW61.4-BAT-AC-G10</td>
                          <td>1000 points - $1000 AUD</td>
                        </tr>
                        <tr>
                          <td>GW92.1-BAT-AC-G10</td>
                          <td>1500 points - $1500 AUD</td>
                        </tr>
                        <tr>
                          <td>GW102.4-BAT-AC-G10</td>
                          <td>1750 points - $1750 AUD</td>
                        </tr>
                        <tr>
                          <td>GW112.6-BAT-AC-G10</td>
                          <td>2000 points - $2000 AUD</td>
                        </tr>
                        <tr>
                          <td>BAT208kWh-GW208.9-BAT-LC-G10</td>
                          <td>3500 points -$3500 AUD</td>
                        </tr>
                        <tr>
                          <td>ESA125kW/261kWh-GW125/261-ESA-LCN-G10</td>
                          <td>4000 points - $4000 AUD</td>
                        </tr>
                        <tr>
                          <td>ESA125kW/261kWh-GW125/261-ESA-LCN-G11</td>
                          <td>4000 points - $4000 AUD</td>
                        </tr>
                        <tr>
                          <td>ET80kW-GW80K-ET-G10</td>
                          <td>1000 points - $1000 AUD</td>
                        </tr>
                        <tr>
                          <td>ET100kW-GW100K-ET-G10</td>
                          <td>1000 points - $1000 AUD</td>
                        </tr>
                        <tr>
                          <td>GT100kW-GW100K-GT</td>
                          <td>1000 points - $1000 AUD</td>
                        </tr>
                        <tr>
                          <td>GT110kW-GW110K-GT</td>
                          <td>1000 points - $1000 AUD</td>
                        </tr>
                        <tr>
                          <td>GT125kW-GW125K-GT</td>
                          <td>1000 points - $1000 AUD</td>
                        </tr>
                      </table>
                    </TimedComponent>
                    <p>
                      The program end date is 31st of December 2026 or until $20
                      Million AUD of rewards value has been successfully
                      claimed. No further claims will be able to be made once
                      reached.
                    </p>
                    <p>
                      Don't miss out - claim your rewards today and use it on
                      anything from our extensive online catalogue!
                    </p>
                  </div>
                </IntroContainer>
              </Col>
            </Row>
            <StepsRow>
              <Col xs={12} sm={12} md={6} lg={3} className="flex">
                <StepContainer>
                  <IconWrapper height="90px" width="90px">
                    <img src={Step1Image} alt="" />
                  </IconWrapper>
                  <h2>Step 1</h2>
                  <p>
                    Purchase a qualifying GoodWe model from your distributor.
                  </p>
                </StepContainer>
              </Col>
              <Col xs={12} sm={12} md={6} lg={3} className="flex">
                <StepContainer>
                  <IconWrapper height="90px" width="90px">
                    <img src={Step2Image} alt="" />
                  </IconWrapper>
                  <h2>Step 2</h2>
                  <p>
                    Photograh and record the serial number of each battery
                    module you’ve purchased.
                  </p>
                </StepContainer>
              </Col>
              <Col xs={12} sm={12} md={6} lg={3} className="flex">
                <StepContainer>
                  <IconWrapper height="90px" width="90px">
                    <img src={Step3Image} alt="" />
                  </IconWrapper>
                  <h2>Step 3</h2>
                  <p>
                    Visit goodwerewards.com.au, register your company account,
                    go to the Claim page, and enter all the required fields for
                    the purchase including serial number details, purchase date,
                    photos of serial numbers. We have a bulk upload option for
                    20 plus serial numbers, making claiming easier.
                  </p>
                </StepContainer>
              </Col>
              <Col xs={12} sm={12} md={6} lg={3} className="flex">
                <StepContainer>
                  <IconWrapper height="90px" width="90px">
                    <img src={Step4Image} alt="" />
                  </IconWrapper>
                  <h2>Step 4</h2>
                  <p>
                    Once your claim is veriﬁed, your point balance will be
                    updated. Redeem points to spend on a wide range of rewards
                    from our catalogue.
                  </p>
                </StepContainer>
              </Col>
            </StepsRow>
            <Row>
              <Col>
                <VideoContainer>
                  <VideoEmbed videoId="i979mYPBgfg" title="GoodWe Video" />
                </VideoContainer>
              </Col>
            </Row>
            <Row className="spacer--bottom">
              <Col>
                <HomeLinksContainer>
                  <HomeLink to="/claim" className="btn1">
                    <span>Claim form</span>
                  </HomeLink>
                  <HomeLink to="/rewards" className="btn2">
                    <span>Rewards</span>
                  </HomeLink>
                  <HomeLink to="/faqs" className="btn3">
                    <span>FAQs</span>
                  </HomeLink>
                </HomeLinksContainer>
              </Col>
            </Row>
          </Grid>
        </BgImage>
      </PrivateComponent>
    </div>
  );
};

HomePage.propTypes = {
  settings: PropTypes.object.isRequired,
};

export default withSettings(HomePage);
